import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "counter"];
  static values = {
    maxLength: Number,
  };

  connect() {
    this.updateCounter();
  }

  updateCounter() {
    const currentLength = this.inputTarget.value.length;
    const remaining = this.maxLengthValue - currentLength;
    this.counterTarget.textContent = `${currentLength}/${this.maxLengthValue} characters`;

    if (remaining <= 20) {
      this.counterTarget.classList.add("text-warning");
    } else {
      this.counterTarget.classList.remove("text-warning");
    }
  }
}
